var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.5,
    stroke: "#2F2F2F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5463 20.2049C31.4566 19.871 31.2808 19.5665 31.0365 19.3218C30.7922 19.0772 30.4879 18.901 30.1541 18.8109C28.9254 18.4805 24 18.4805 24 18.4805C24 18.4805 19.0746 18.4805 17.8459 18.8092C17.5119 18.899 17.2075 19.075 16.9631 19.3197C16.7188 19.5644 16.5431 19.8691 16.4537 20.2031C16.125 21.4336 16.125 24 16.125 24C16.125 24 16.125 26.5664 16.4537 27.7951C16.6348 28.4736 17.1691 29.008 17.8459 29.1891C19.0746 29.5195 24 29.5195 24 29.5195C24 29.5195 28.9254 29.5195 30.1541 29.1891C30.8326 29.008 31.3652 28.4736 31.5463 27.7951C31.875 26.5664 31.875 24 31.875 24C31.875 24 31.875 21.4336 31.5463 20.2049ZM22.4355 26.3555V21.6445L26.5137 23.9824L22.4355 26.3555Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.6b6aafac6e26bc664c75c896261699cc.svg";
export { ForwardRef as ReactComponent };